import React, { Component } from "react";
import Modal from "@acadia-ui/modal";

import "./modal.scss";
import ModalHelpers from "./ModalHelpers";
import Button from "@acadia-ui/button";

class ArchiveActivationConfirmationModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			row: null
		};
	}

	componentDidMount() {
		this.props.archiveConfirmationModal(this);
	}

	componentWillUnmount() {
		this.props.archiveConfirmationModal(undefined);
	}

	setRowToArchive = (row) => {
		this.setState({ row });
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		ModalHelpers.openCloseNoData(event, this.updateModalState, this.state);
	};

	updateModalState = () => {
		this.setState({ open: !this.state.open });
	};

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.onSubmit(this.state.row);
		this.triggerOpenClose();
	};

	render() {
		return (
			<>
				<Modal
					id="archive__campaign"
					heading="Archive Campaign"
					description="By clicking Archive, you will be archiving the selected campaigns. Do you want to continue?"
					isOpen={this.state.open}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsRight: (
							<>
								<Button display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-archive-campaign">
									Cancel
								</Button>
								<Button display="primary" onClick={this.handleSubmit} data-tracking-id-alt="confirm-archive-campaign">
									Archive
								</Button>
							</>
						)
					}}
				>
					<div style={{ height: "50px" }}></div>
				</Modal>
			</>
		);
	}
}

export default ArchiveActivationConfirmationModal;
